"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var SisHeaderViewFormComponent = /** @class */ (function () {
    function SisHeaderViewFormComponent() {
        this.workflowActions = [];
        this.withEditButton = true;
        this.withCommentButton = false;
        this.isReadonly = false;
        this.onWfSelect = new core_1.EventEmitter();
        this.editClick = new core_1.EventEmitter();
    }
    SisHeaderViewFormComponent.prototype.hasWorkflow = function () {
        return (this.workflowActions.length > 0 ||
            (this.entity === null && this.isReadonly));
    };
    SisHeaderViewFormComponent.prototype.isEditable = function () {
        return (this.hasEditPermission || (this.entity === null && this.isReadonly));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisHeaderViewFormComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], SisHeaderViewFormComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisHeaderViewFormComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisHeaderViewFormComponent.prototype, "userHelpItems", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisHeaderViewFormComponent.prototype, "workflowActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisHeaderViewFormComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisHeaderViewFormComponent.prototype, "labelMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisHeaderViewFormComponent.prototype, "hasEditPermission", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisHeaderViewFormComponent.prototype, "withDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisHeaderViewFormComponent.prototype, "withEditButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisHeaderViewFormComponent.prototype, "withCommentButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisHeaderViewFormComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisHeaderViewFormComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisHeaderViewFormComponent.prototype, "formActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisHeaderViewFormComponent.prototype, "exportTemplates", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisHeaderViewFormComponent.prototype, "onWfSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisHeaderViewFormComponent.prototype, "editClick", void 0);
    SisHeaderViewFormComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-header-view-form',
            template: require('./sis-header-view-form.component.html'),
        })
    ], SisHeaderViewFormComponent);
    return SisHeaderViewFormComponent;
}());
exports.SisHeaderViewFormComponent = SisHeaderViewFormComponent;
//# sourceMappingURL=sis-header-view-form.component.js.map